import type { Article } from "./types";
import catAdoption from "./jak-przygotowac-sie-do-adopcji-kota";
import adoptionProcess from "./jak-wyglada-adopcja-psa-lub-kota-ze-schroniska";
import heatCare from "./pies-i-kot-w-upal-jak-schlodzic";

export const articles: Article[] = [heatCare, catAdoption, adoptionProcess].sort(
  (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
);

export const getArticleBySlug = (slug: string): Article | undefined =>
  articles.find((a) => a.slug === slug);

export type { Article };
